import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qsh7rux99c: FaireBrandEntity = {
  token: "b_qsh7rux99c",
  type: "brand",
  name: "Cabin Time Games",
  avatarUrl: "https://cdn.faire.com/fastly/d1131abbb6a9b21c77fe2f4450620f24fec1d972e79c2c77aa64fdccfb0e62cf.png",
  bannerUrl: "https://cdn.faire.com/fastly/68d98c419fb6aa8a4f461710f28ac066cc1016adb7c0f522e4da5d5bbdae7de6.png",
  logoUrl: "https://cdn.faire.com/fastly/d1131abbb6a9b21c77fe2f4450620f24fec1d972e79c2c77aa64fdccfb0e62cf.png",
  heroImageUrl: "https://cdn.faire.com/fastly/68d98c419fb6aa8a4f461710f28ac066cc1016adb7c0f522e4da5d5bbdae7de6.png",
  location: "Starlight, PA, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description: "What if the best part of summer camp could come home with you?\nAfter 28 years as a summer camp director, Allison Miller knows that the moments kids remember most are often the simplest: a room full of laughter, a little friendly competition, and everyone asking to play one more round. Working with Austin Nelson, a longtime camp program director, they created Cabin Time Games to bring that feeling to families wherever they gather.\nThe first collection turns three camp favorites into easy to learn card games: Cabin Time Games: Dodgeball, Cabin Time Games: Four Corners, and Cabin Time Games: Tug of War. Each captures the excitement of the original in a game you can pull out at home, on a rainy day, or while traveling. Real campers helped test and refine the games over three summers.\nBecause every kid deserves a little camp magic, even when they can’t go to camp.",
  meta: {
    source: "api",
    importedAt: "2026-10-09T07:53:33.349Z",
    importedBy: "entity-db-cli"
  }
};
